// extracted by mini-css-extract-plugin
module.exports = {"icon":"AcceptanceName_icon__1JYUk","root":"AcceptanceName_root__CWqY_","iconWrap":"AcceptanceName_iconWrap__1Jwa2","formItem":"AcceptanceName_formItem__1VDNE"};